import { localizedPath } from "../core/localePaths";

export function blurActiveElement() {
  if (typeof document === "undefined") return;
  const el = document.activeElement;
  if (!el || el === document.body || el === document.documentElement) return;
  if (typeof el.blur === "function") el.blur();
}

export function buildPageUrl(page, locale, query = null) {
  const targetPath = localizedPath(page, locale || "en");
  if (!query || Object.keys(query).length === 0) return targetPath;
  const queryString = new URLSearchParams(query).toString();
  return queryString ? `${targetPath}?${queryString}` : targetPath;
}

export function currentAppUrl() {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}`;
}

export function pushAppUrl(targetUrl, { replace = false, state = {} } = {}) {
  if (typeof window === "undefined") return false;
  if (currentAppUrl() === targetUrl) return false;
  blurActiveElement();
  if (replace) {
    window.history.replaceState(state, "", targetUrl);
  } else {
    window.history.pushState(state, "", targetUrl);
  }
  return true;
}

export function navigateToPageUrl(page, locale, options = {}) {
  const targetUrl = buildPageUrl(page, locale, options.query || null);
  return pushAppUrl(targetUrl, {
    replace: Boolean(options.replace),
    state: { page, locale },
  });
}

export function hardNavigateToUrl(targetUrl) {
  if (typeof window === "undefined") return;
  blurActiveElement();
  window.location.assign(targetUrl);
}
